module.exports = __webpack_public_path__ + "img/03-Livepen-BT-PD02.ff752933.png";